module.exports = __webpack_public_path__ + "static/media/8.5125d1cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/orders/8.jpg
// module id = 1740
// module chunks = 0